import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const SERVICES = [
  {
    title: "Rénovation",
    text: "Réinventer un appartement ou une maison, partiellement ou entièrement.",
    img: "https://images.unsplash.com/photo-1705321963943-de94bb3f0dd3?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    title: "Extension & surélévation",
    text: "Créer de nouveaux mètres carrés et faire évoluer votre maison.",
    img: "https://images.unsplash.com/photo-1753893558279-8beaad18dd96?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    title: "Aménagement intérieur",
    text: "Concevoir des espaces fonctionnels, harmonieux et adaptés à votre quotidien.",
    img: "https://images.unsplash.com/photo-1610177534644-34d881503b83?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    title: "Construction",
    text: "Transformer une idée en projet de maison et être accompagné dans les différentes étapes.",
    img: "https://images.unsplash.com/photo-1748063578185-3d68121b11ff?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
];

export const Services = ({ onDiscover }) => (
  <section id="services" data-testid="services-section" className="bg-white py-20 sm:py-28">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal>
        <p className="text-xs font-bold uppercase tracking-[0.25em] text-cognac sm:text-sm">
          Nos services
        </p>
        <h2 className="mt-4 max-w-3xl font-display text-4xl font-medium tracking-tight text-navy sm:text-6xl">
          Un accompagnement adapté à <span className="italic text-sage">votre projet</span>
        </h2>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {SERVICES.map((s, i) => (
          <Reveal key={s.title} delay={i * 0.08}>
            <article
              data-testid={`service-card-${i}`}
              className="group flex h-full flex-col rounded-3xl bg-cream p-4 pb-7 transition-all duration-300 hover:-translate-y-1 hover:shadow-md"
            >
              <div className="overflow-hidden rounded-2xl">
                <img
                  src={s.img}
                  alt={s.title}
                  loading="lazy"
                  className="h-52 w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                />
              </div>
              <div className="flex flex-1 flex-col px-3 pt-6">
                <h3 className="font-display text-2xl font-medium text-navy">{s.title}</h3>
                <p className="mt-2.5 flex-1 text-sm leading-relaxed text-stone-500">{s.text}</p>
                <button
                  data-testid={`service-discover-${i}`}
                  onClick={onDiscover}
                  className="mt-5 flex w-fit items-center gap-1.5 text-sm font-bold text-cognac transition-colors duration-300 hover:text-navy"
                >
                  Découvrir
                  <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:rotate-45" />
                </button>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
